import loggingService from '../util/loggingService'

var serviceName = 'SignificantPeriodInstance'
var path = '/SignificantPeriodInstance/'
var isDebug = false

function get (http, id) {
    loggingService.log(isDebug, serviceName, 'get')
    return http.get(path + 'Get?significantPeriodInstanceId=' + id)
}

function search (http, searchObject) {
    loggingService.log(isDebug, serviceName, 'search by ' + searchObject.ProjectId)
    return http.post(path + 'Search', searchObject)
}

function getSignificantPeriodList () {
    return [
        {significantPeriodId: 1, description: 'Prehistoric'},
        {significantPeriodId: 2, description: 'Protohistoric (1720-1800)'},
        {significantPeriodId: 3, description: 'Early Historic (1800-1842)'},
        {significantPeriodId: 4, description: 'Pre-territorial (1842-1868)'},
        {significantPeriodId: 5, description: 'Territorial (1868-1890)'},
        {significantPeriodId: 6, description: 'Expansion (1890-1928)'},
        {significantPeriodId: 7, description: 'Depression (1920-1939)'},
        {significantPeriodId: 8, description: 'WWII-era (1940-1946)'},
        {significantPeriodId: 9, description: 'Post-WWII (1947-1950)'},
        {significantPeriodId: 10, description: 'Modern (1951-present)'}
    ]
}

function getPrehistoricAgeList () {
    return [
        {prehistoricAgeId: 1, description: 'Unknown Prehistoric'},
        {prehistoricAgeId: 2, description: 'Paleoindian'},
        {prehistoricAgeId: 3, description: 'Early Archaic'},
        {prehistoricAgeId: 4, description: 'Middle Archaic'},
        {prehistoricAgeId: 5, description: 'Late Archaic'},
        {prehistoricAgeId: 6, description: 'General Archaic'},
        {prehistoricAgeId: 7, description: 'Late Prehistoric'},
        {prehistoricAgeId: 8, description: 'Protohistoric'}
    ]
}

function getPrehistoricPhaseList () {
    return [
        {prehistoricPhaseId: 1, description: 'Great Divide Basin'},
        {prehistoricPhaseId: 2, description: 'Opal'},
        {prehistoricPhaseId: 3, description: 'Pine Spring'},
        {prehistoricPhaseId: 4, description: 'Deadman Wash'},
        {prehistoricPhaseId: 5, description: 'Uinta'},
        {prehistoricPhaseId: 6, description: 'Firehole'}
    ]
}

export default {
    get: get,
    search: search,
    getSignificantPeriodList: getSignificantPeriodList,
    getPrehistoricAgeList: getPrehistoricAgeList,
    getPrehistoricPhaseList: getPrehistoricPhaseList
}



// WEBPACK FOOTER //
// ./src/services/siteForm/significantPeriodService.js